"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLinesNumberOfRounds = void 0;
const getOrderLinesNumberOfRounds = (order_lines) => {
    if (!order_lines)
        return 0;
    return order_lines.filter((orderLine) => {
        return orderLine.type === "GOLF";
    }).length;
};
exports.getOrderLinesNumberOfRounds = getOrderLinesNumberOfRounds;
